<template>
    <div>
        <div class="container-fluid">
            <div class="contenedor">           
                <b-row>
                    <b-col>
                         <div align="center" class="mb-2">
                            <b-button variant="primary" @click="listProformas">Actualizar<i class="fa fa-sync-alt"></i></b-button>
                        </div>
                    </b-col>
                    <b-col md="2">
                        <b-form-group horizontal label="Mostrar" class="mb-0">
                        <b-input-group>
                            <b-form-select v-model="limite" slot="append" @input="listProformas">
                            <option :value="10">10</option>
                                <option :value="25">25</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </b-form-select>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <template v-if="loading">
                <div class="text-center mb-5 mt-5">
                <h3>
                Cargando
                <i class="fa fa-spin fa-spinner"></i>
                </h3>
                </div>
                </template>
                <template v-else>
                <b-table
                head-variant="light"
                :outlined="outlined"
                responsive 
                small 
                :items="ordenPago" 
                :fields="ordenPago_fields">
                <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                <template slot="emision" slot-scope="row">
                    {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                </template>
                <template slot="receptor" slot-scope="row" align="left">
                    {{row.item.ordenPago.receptor.nro}} - {{row.item.ordenPago.receptor.razonSocial}}
                </template>
                <template slot="importetotales" slot-scope="row">     
                   {{row.item.ordenPago.moneda.simbolo}}  {{row.item.ordenPago.totales.importeTotal.toFixed(2)}}
                </template>
                <template slot="estado" slot-scope="row">
                    <template>
                      <b-badge variant="success">Pagado</b-badge>
                    </template>
                </template>
                <template slot="acciones" slot-scope="row">
                    <button  @click="row.toggleDetails" type="button" class="btn btn-sm">
                      <template v-if="!row.detailsShowing">
                        <i class="fa fa-plus"></i>                                
                      </template>
                      <template v-else>
                        <i class="fa fa-minus    "></i>
                      </template>
                    </button>
                </template>
                <template v-slot:row-details="row">
                    <b-table
                        responsive
                        small
                        :items="row.item.ordenPago.items"
                        :fields="itemsOrden"
                        table-variant="info">
                    </b-table>
                  </template>
                </b-table>
                </template>
                <b-row>
                <b-col cols="9">
                    <div>
                        <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                    </div>
                </b-col>
                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                    <div >
                    <b-pagination
                        :total-rows="total"
                        v-model="currentpage"
                        @input="listProformas"
                        :per-page="limite"
                        align="center"
                    ></b-pagination>
                    </div>
                </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name:'OPEmitidas',
        data:() =>{
            return {
            currentpage:1,
            limite:20,
            orden:'desc',
            sistema:"facturaonline",
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            array:[],
            ordenPago:[],
            ordenPago_fields: [
                {key: 'index', label: 'Nro', sorteable: true},
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'importetotales', label: 'Monto Total', sorteable: true},
                {key: 'estado', label: 'Estado'},
                {key: 'acciones', label: 'Acciones'}
            ],
            outlined:true,
            loading:false,
            pagado:1,
            itemsOrden:[
                {key:"codigoProducto", label:"Código"},
                {key:"descripcion", label:"Descripción"},
                {key:"observacionItem", label:"Obs. Producto"},
                {key:"cantidad", label:"Cantidad"},
                {key:"precioVentaUnitario", label:"Precio Unitario"}
            ],
        }
    },
    mounted() {
        this.listProformas()
    },
    methods:{
        listProformas: function () {
            this.loading = true
            axios
            .post(process.env.VUE_APP_API_URL + 'ordenpago/listar', {
                token: this.$store.getters.userToken,
                page: this.currentpage,
                limit: this.limite,
                order: this.orden,
                sistema:this.sistema,
                pagado:this.pagado
            })
            .then(response => (
                this.loading = false,
                this.ordenPago = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error => {
                this.$snotify.error(error.response.data.msg,'Error')
            })
        },
    }
}
</script>